import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const organizationsAdapter = getAdapter();
const BILLTO_ORGANIZATION_ROLE = 1;
const CUSTOMER_ORGANIZATION_ROLE = 0;
const BROKER_ORGANIZATION_ROLE = 2;
const CHASSIS_PROVIDER_ROLE = 4;
const SSL_ROLE = 5;

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState: organizationsAdapter.getInitialState(),
  reducers: {
    setOrganizations: (state, { payload: { organizations } }) => {
      organizationsAdapter.setAll(state, organizations);
    },
    addOrganization: (state, { payload: { organization } }) => {
      organizationsAdapter.addOne(state, organization);
    },
  },
});

const selectors = organizationsAdapter.getSelectors(({ organizations }) => organizations);

export const getOrganizationsIncludingDeleted = (state) => selectors.selectAll(state);

export const getOrganizations = (state) => getOrganizationsIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const getOrganizationById = (state, id) => selectors.selectById(state, id);

export const getBillTos = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(BILLTO_ORGANIZATION_ROLE));
export const getCustomers = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(CUSTOMER_ORGANIZATION_ROLE));
export const getShipLines = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(SSL_ROLE));
export const getChassisProviders = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(CHASSIS_PROVIDER_ROLE));
export const getChassisContractAgreementParties = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(CHASSIS_PROVIDER_ROLE) || roles.includes(SSL_ROLE));

export const getBrokers = (state) => getOrganizations(state).filter(({ roles }) => roles.includes(BROKER_ORGANIZATION_ROLE));

export const { setOrganizations, addOrganization } = organizationsSlice.actions;

export default organizationsSlice.reducer;
